import {
  clearPendingApplyListingId,
  getPendingApplyListingId,
} from 'api/utils/pendingApplyListing'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const PostRegisterChoicePage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const propertyId = getPendingApplyListingId()
    if (propertyId) {
      clearPendingApplyListingId()
      navigate(`/listing/${propertyId}`, {
        state: { resumeInterest: true },
        replace: true,
      })
    }
  }, [navigate])

  return (
    <div className="min-h-screen bg-imovWhiteShadow flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg border border-imovGray/20 p-6 sm:p-8">
        <h1 className="text-2xl font-bold text-imovSecondary text-center mb-3">
          Bem-vindo ao EasyBail
        </h1>
        <p className="text-sm text-gray-600 text-center mb-6">
          O que você deseja fazer agora?
        </p>

        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={() => navigate('/create-profile', { state: { source: 'register' } })}
            className="w-full px-4 py-3 rounded-lg bg-imovPrimary text-white font-semibold text-sm hover:bg-imovPrimaryHover transition-colors min-h-[44px]"
          >
            Estou buscando um aluguel
          </button>
          <button
            type="button"
            onClick={() => navigate('/create-ad', { state: { newListing: true } })}
            className="w-full px-4 py-3 rounded-lg border border-imovPrimary text-imovPrimary font-semibold text-sm hover:bg-imovPrimary/5 transition-colors min-h-[44px]"
          >
            Quero transferir meu aluguel
          </button>
        </div>
      </div>
    </div>
  )
}

export default PostRegisterChoicePage
